import { ThemeOptions } from "@mui/material";

export const RadioA11y: ThemeOptions = {
  components: {
    MuiRadio: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible .MuiSvgIcon-root': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
            borderRadius:0.2
          },

          // Fallback: when focus is on the inner input (covers both icons)
          '& .PrivateSwitchBase-input:focus-visible ~ .MuiSvgIcon-root': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
            borderRadius:0.2
          },
        }),
      },
    },
  },
};
